import { GetPartnerDataResponse } from '@/modules/manage-player/type'
import { PencilIcon, Search } from 'lucide-react'
import { Link } from 'react-router-dom'
import { ColumnDef } from '@tanstack/react-table'
import { Button } from '@/common/ui/button'
import AddCreditDialog from './components/AddCreditDialog'
import IsActiveToggle from './components/IsActiveToggle'

export const columns: ColumnDef<GetPartnerDataResponse>[] = [
	{
		accessorKey: 'nickname',
		header: 'ชื่อ',
	},
	{
		accessorKey: 'percentage',
		header: 'ร้อยละ',
	},
	{
		id: 'isActive',
		header: 'เปิดใช้งาน',
		cell: ({ row }) => <IsActiveToggle row={row.original} />,
	},
	{
		id: 'lastPaymentDate',
		header: 'จ่ายล่าสุด',
		cell: ({ row }) => {
			const lastPaymentDate = row.original.lastPaymentDate
			if (!lastPaymentDate) {
				return <span className="text-muted-foreground">-</span>
			}
			const date = new Date(lastPaymentDate)
			const daysSincePayment = Math.floor(
				(Date.now() - date.getTime()) / (1000 * 60 * 60 * 24),
			)
			const colorClass =
				daysSincePayment <= 30 ? 'text-green-600' : 'text-yellow-600'
			return (
				<span className={colorClass}>
					{date.toLocaleDateString('th-TH', {
						year: 'numeric',
						month: 'short',
						day: 'numeric',
					})}
				</span>
			)
		},
	},
	{
		id: 'viewPlayers',
		header: 'รายละเอียด',
		cell: ({ row }) => (
			<Link to={`/operator/partner/${row.original.id}/players`}>
				<Button variant="outline" size="sm" className="flex items-center gap-1">
					<Search className="h-4 w-4" />
					ดูรายละเอียด
				</Button>
			</Link>
		),
	},
	{
		id: 'addCredit',
		header: 'เพิ่มเครดิต',
		cell: ({ row }) => <AddCreditDialog partner={row.original} />,
	},
	{
		id: 'editPartner',
		header: 'แก้ไข',
		cell: ({ row }) => (
			<Link to={`/operator/partner/${row.original.id}`}>
				<PencilIcon className="h-4 w-4" />
			</Link>
		),
	},
]

export const writeAccessorKeys = ['editPartner', 'addCredit', 'isActive']
